import type { PartnerOrganization } from '@reach/shared-types/workos-auth';
import { Check, Loader2 } from 'lucide-react';
import { OrganizationLogo } from './OrganizationLogo';
import styles from './OrgSwitcherGroup.module.css';

interface OrganizationOptionProps {
  organization: PartnerOrganization;
  currentId?: string;
  switchingToId: string | null;
  focused: boolean;
  onSelect: (id: string) => void;
  onFocus: () => void;
}
export const OrganizationOption = ({
  organization,
  currentId,
  switchingToId,
  focused,
  onSelect,
  onFocus,
}: OrganizationOptionProps) => {
  const organizationIsSwitching = switchingToId === organization.id;
  const organizationIsCurrent = organization.id === currentId;
  return (
    <button
      type="button"
      className={styles.option}
      data-focused={focused}
      aria-current={organizationIsCurrent ? 'true' : undefined}
      disabled={organizationIsSwitching}
      onClick={() => onSelect(organization.id)}
      onMouseEnter={onFocus}>
      <OrganizationLogo name={organization.name} logoUrl={organization.logoUrl} />
      <span className={styles.organizationName}>
        <strong>{organization.name}</strong>
        {organization.domain && <small>{organization.domain}</small>}
      </span>
      {organizationIsSwitching && <Loader2 className={styles.spinner} aria-hidden />}
      {!organizationIsSwitching && organizationIsCurrent && <Check aria-hidden />}
    </button>
  );
};
